import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getClients = () => api.get('/clients').then(r => r.data);
export const getClient = (slug) => api.get(`/clients/${slug}`).then(r => r.data);
export const getBlog = () => api.get('/blog').then(r => r.data);
export const getBlogPost = (slug) => api.get(`/blog/${slug}`).then(r => r.data);
export const getTestimonials = () => api.get('/testimonials').then(r => r.data);
export const getNews = () => api.get('/news').then(r => r.data);
export const getNewsItem = (slug) => api.get(`/news/${slug}`).then(r => r.data);
export const postContact = (payload) => api.post('/contact', payload).then(r => r.data);
export const postNewsletter = (payload) => {
  const body = typeof payload === 'string' ? { email: payload } : payload;
  return api.post('/newsletter', body).then(r => r.data);
};
